import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountUserService } from 'src/app/services/account-user.service';
@Component({
  selector: 'app-create-label',
  templateUrl: './create-label.component.html',
  styleUrls: ['./create-label.component.css']
})
export class CreateLabelComponent implements OnInit {
  public salesModelForm: UntypedFormGroup;
  title: string;
  btndisabled = false;

  formErrors = {
    'code': '',
    'displayName': '',
    'description': ''
  };

  ValidationMessages = {
    'code': {
      'required': 'Code  is required',
      'whitespace': 'Code is invalid'

    },
    'displayName': {
      'required': 'DisplayName  is required',
      'whitespace': 'DisplayName is invalid'
    },
    'description': {
      'required': 'Description  is required',
      'whitespace': 'Description is invalid'
    },
  };
  api_success: string;
  api_error: any;
  btnsave: string;
  models: any = [];
  tillMonth = '';
  commissionPct = '';
  displayName: any;
  label: any;
  description: any;
  modelMaxPercentage;
  scconfig: any = {};
  labelDataDetails: any;
  salesModelId: any;
  defaultComModelPct: any;
  valueSet = [];
  accountId: any;
  id: any;
  constructor(
    private matDialog: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountuserService: AccountUserService,
  ) {
    this.models = [];
    this.btnsave = 'SAVE';
    this.title = 'CREATE';
    if (data['type'] === 'edit') {
      this.updateSalesModel();
      this.btnsave = 'UPDATE';
      this.title = 'UPDATE';
    }

  }
  updateSalesModel() {
    this.labelDataDetails = this.data['labels'];
    this.id = this.labelDataDetails.id;
    this.accountId = this.labelDataDetails.accountId;
    this.label = this.labelDataDetails.label;
    this.displayName = this.labelDataDetails.displayName;
    this.description = this.labelDataDetails.description;
  }
  ngOnInit() {
  }
  onSalesModelSubmit() {
    this.valueSet = [];
    this.valueSet.push(
            { 'value': true, 'shortValue': true },
            { 'value': false, 'shortValue': false });
    const data = {
       id: this.id,
      label: this.label,
      displayName: this.displayName,
      description: this.description,
      valueSet: this.valueSet
    
    };
    // console.log(data)
    if (this.data['type'] === 'add') {
      this.saveLabel(data);
    } else if (this.data['type'] === 'edit') {
       this.updateLabelForm(data);
    }


  }
  saveLabel(data) {
   
    this.api_error = '';
    this.api_success = '';
    
    this.accountuserService.createLabels(data)
    .subscribe(res => {
    this.api_success = 'Label created successfully';
      setTimeout(() => {
        this.matDialog.close();
       }, 2000);
     },
      (error) => {
        this.api_error = error.error;
    });

  }
  updateLabelForm(form_data) {
    this.api_error = '';
    this.api_success = '';
    this.accountuserService.updateLabels(form_data)
    .subscribe(res => {
    this.api_success = 'Label updated successfully';
      setTimeout(() => {
        this.matDialog.close();
       }, 2000);
     },
      (error) => {
        this.api_error = error.error;
    });
  }
  // onAdd() {
  //   this.models.push({ 'tillMonth': this.tillMonth, 'percentage': this.percentage });
  //   this.tillMonth = '';
  //   this.percentage = '';
  // }
  // ondeleteModel(modelObject) {
  //   this.models = this.models.filter(model => model !== modelObject);
  // }

  logValidationErrors(group: UntypedFormGroup = this.salesModelForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });


  }

}